enum TransactionMethod {
  IBAN = "iban",
  CARD = "card",
  CRYPTO = "crypto",
  IMPORT = "import",
  TRANSFER = "transfer",
  EXCHANGE = "exchange",
  CONVERT = "convert",
}

export { TransactionMethod };
